/**
 * @file Album folder discovery related constants.
 */

const ALBUM_LENGTH_DROPDOWN_CONVERSION = 15;

/**
 * @enum PPGD_JOIN_TYPE
 * @type {{PURCHASE: string, JOIN: string}}
 */
const PPGD_JOIN_TYPE = {
  PURCHASE: 'PURCHASE',
  JOIN: 'JOIN',
};

/**
 * GTM event names for the face-recognition-disabled join funnel. Used to
 * measure the merged (search + confirm in one step) onboarding.
 */
const NO_FR_JOIN_TRACKING = {
  TYPE: 'no_fr_join',
  ACTION: {
    IDENTITY_SELECTED: 'identity_selected',
    IDENTITY_REMOVED: 'identity_removed',
    JOIN_SUBMITTED: 'join_submitted',
    JOIN_SUCCEEDED: 'join_succeeded',
    JOIN_FAILED: 'join_failed',
  },
};

export {
  ALBUM_LENGTH_DROPDOWN_CONVERSION,
  PPGD_JOIN_TYPE,
  NO_FR_JOIN_TRACKING,
};
